import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { AccidentSheetSettings, AccidentSheetStateType } from 'src/shared/types/src';

const initialState: AccidentSheetStateType = {
    settingLoading: false,
    settings: {} as AccidentSheetSettings,
}

const accidentSlice = createSlice({
    name: 'accidentSlice',
    initialState,
    reducers: {
        setSettingsLoading: (state, action: PayloadAction<boolean>) => {
            state.settingLoading = action.payload;
        },
        setSettingsData: (state, action: PayloadAction<AccidentSheetSettings>) => {
            state.settings = action.payload;
        }
    }
});

export const accidentAction = accidentSlice.actions;
export default accidentSlice.reducer;